<template lang="pug">
	.creative-services-manager.flex-col.space-large
		Loader(v-if="isLoading", :fullscreen="true")
		.upper.font-big.grey(v-if="showHeader") {{$tCaption('Services manager')}}
		.flex-col.space-large
			span(v-if="isLoaded && !services.length") {{$tCaption('There is no any used services in creative.')}}
			.service.flex-col.space(v-for="service in services")
				.flex-row
					a.service-info.flex-row.space-medium.align-center.font-big.grey(@click="$set(service, 'expanded', !service.expanded)")
						fas.grey(:icon="service.expanded ? 'chevron-down' : 'chevron-right'", size="2xs")
						span {{service.service.Name}}
				.service-margin.flex-col.space(v-if="service.expanded")
					.font-small.grey {{service.insertions.reduce((t, r) => t + r.tags.length, 0)}} {{$tCaption('occurrence(s)')}}
					.flex-col.space-medium
						.insertion-info.flex-col.space-medium(v-for="insertion in service.insertions")
							.flex-col.space(v-for="tag in insertion.tags")
								.flex-col.space
									.flex-row
										.flex-row.space.clickable.hoverable(:title="$tCaption('Open insertion')", @click="openInsertion(insertion.insertion)")
											span {{getTime(insertion.insertion.StartTime)}}
											.insertion-text.nowrap.text-overflow(v-html="tag.insertionText")
									.flex-col.space.font-small
										table
											tr(v-for="param in getTagParams(tag, service.service)")
												td(:width="1")
													.param.flex-row.space.align-center
														.flex-row.space-small.nowrap
															.grey [
															.grey.hoverable.clickable(@click="editParam(tag, param, service.service)") {{param.caption || param.name}}:
															.flex-row.associated-template-field.align-center(v-if="param.association", :title="`\"${param.caption || param.name}\" ${$tCaption('linked with template field')} \"${param.association}\"`")
																span [!
																span {{param.association}}
																span ]
															span(v-else) {{param.displayValue}}
															.grey ]
												td.lr-padding(:class="{ 'opacity-low': !param.association }")
													template(v-if="creative.IsTemplate")
														.checkbox(@click="e => onTemplateFieldCheck(!param.association, param, tag, service.service)")
															DxCheckbox.font-small(:value="!!param.association", :text="$tCaption('Template field')")
		Popup(v-if="isEditingParam && editingParam", :popupVisible="isEditingParam", :width="420", :height="340", :title="editingParam.Caption || editingParam.Name")
			CreativeServicesManagerParamEditor(ref="paramEditor", :tag="editingTag", :param="editingParam", :service="editingService", :servicesStructure="services", 
				:templateFields="templateFields", @change="onEditingParamChange", @associations-change="onAssociationsChange", :allowTemplateFieldCreation="creative.IsTemplate",
				@action="onCreativeServicesAction")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="isEditingParam = false")
				DxButton(:text="$tCaption('Save', '@actions')", type="success", @click="saveParam")
</template>

<script>
	import Loader from 'app-core/Loader.vue';
	import _ from 'lodash';
	import serviceHelper from 'view/webServiceCaller/service-helper';
	import Popup from 'app-core/Popup.vue';
	import CreativeServicesManagerParamEditor from './CreativeServicesManagerParamEditor.vue';
	import DxButton from 'devextreme-vue/button';
	import json5 from 'json5';
	import DxCheckbox from 'devextreme-vue/check-box';
	import creativeServicesHelper from './creative-services-helper';

	export default {
		translationCategory: 'creative.CreativeServicesManager',
		name: 'creative-services-manager',
		components: { Loader, CreativeServicesManagerParamEditor, DxButton, Popup, DxCheckbox },
		props: ['creative', 'insertions', 'showHeader', 'templateFields', 'changedInsertionsData'],
		data() {
			return {
				isLoading: false,
				services: [],
				isLoaded: false,
				allServices: [],
				isEditingParam: false,
				editingParam: null,
				editingService: null,
				editingTag: null,
				editingParamNewValues: {},
				changedInsertions: this.changedInsertionsData || {}
			};
		},
		mounted() {
			if (__DEBUG__)
				window.creativeServicesManager = this;

			this.detectServices();
		},
		methods: {
			async onTemplateFieldCheck(value, param, tag, service) {
				const occurrences = creativeServicesHelper.getOccurrences(param.param, tag, service, this.services, 'param');

				const newAssociations = {};//tag.associations;
				if (value) {
					const templateField = serviceHelper.getTemplateFieldFromParam(param.param);
					let existingTemplateField = this.templateFields.find(f => f.id === templateField.id && f.parentServiceOid === templateField.parentServiceOid 
						&& f.parentServiceOutput === templateField.parentServiceOutput 
						&& f.dataType === templateField.dataType);

					if (!existingTemplateField) {
						await new Promise(res => {
							this.$emit('create-template-field', templateField, () => res());
						});
						existingTemplateField = templateField;
					}

					newAssociations[param.param.Name] = templateField.id;
				}

				occurrences.map(occ => {
					const tag = occ.tag;
					const servicesTags = this.getNodes(tag.ssml, 'adthos\\:wbs');
					const tagEl = servicesTags[occ.tag.index];
					const insertion = occ.insertion;
					const associations = {
						...json5.parse(tagEl.getAttribute('templatefieldsassociation') || '{}'),
						...newAssociations
					};

					if (!value) {
						delete associations[param.param.Name];
					}

					if (associations) {
						tagEl.setAttribute('templatefieldsassociation', json5.stringify(associations, { quote: "'" }));
					}

					this.$set(this.changedInsertions, insertion.Oid, {
						insertion,
						ssml: tag.ssml.outerHTML
					});
				});

				this.$emit('changed-insertions', this.changedInsertions);
				this.detectServices();
			},
			onCreativeServicesAction(action, param) {
				switch(action) {
					case 'create-template-field': {
						if (__DEBUG__)
							console.debug('Create template field from param', { param });
						const templateField = serviceHelper.getTemplateFieldFromParam(param);
						this.$emit('create-template-field', templateField);
						break;
					}
				}
			},
			onEditingParamChange(params, paramsCaptions) {
				this.$set(this.editingParamNewValues, 'params', params);
				this.$set(this.editingParamNewValues, 'paramsCaptions', paramsCaptions);
			},
			onAssociationsChange(associations) {
				const editingAssociations = {};
				editingAssociations[this.editingParam.param.Name] = associations[this.editingParam.param.Name];
				this.$set(this.editingParamNewValues, 'associations', editingAssociations);
			},
			editParam(tag, param, service) {
				this.editingTag = tag;
				this.editingParam = param;
				this.editingService = service;
				this.isEditingParam = false;
				setImmediate(() => this.isEditingParam = true);
			},
			saveParam() {
				const occurrences = this.$refs.paramEditor.occurrences;
				if (__DEBUG__)
					console.debug('Save param', { occurrences, vals: this.editingParamNewValues });
				const param = this.editingParam.param;
				const params = this.editingParamNewValues.params;
				const paramsCaptions = this.editingParamNewValues.paramsCaptions;
				const changedInsertions = this.changedInsertions;
				const newAssociations = this.editingParamNewValues.associations;
				
				occurrences.map(occ => {
					const tag = occ.tag;
					const servicesTags = this.getNodes(tag.ssml, 'adthos\\:wbs');
					const tagEl = servicesTags[occ.tag.index];
					const insertion = occ.insertion;
					const associations = {
						...json5.parse(tagEl.getAttribute('templatefieldsassociation') || '{}'),
						...newAssociations
					};

					Object.keys(params).map(f => {
						const inparam = tagEl.querySelector(`inparam[name="${f}"]`);
						if (inparam) {
							inparam.setAttribute('val', params[f]);
							if (paramsCaptions[f])
								inparam.setAttribute('caption', paramsCaptions[f]);
						}
					});

					if (associations) {
						tagEl.setAttribute('templatefieldsassociation', json5.stringify(associations, { quote: "'" }));
					}

					changedInsertions[insertion.Oid] = {
						insertion,
						ssml: tag.ssml.outerHTML
					}
				});

				this.changedInsertions = { ...this.changedInsertions, ...changedInsertions };
				this.detectServices();

				this.isEditingParam = false;

				this.$emit('changed-insertions', this.changedInsertions);

				if (__DEBUG__)
					console.debug('Replace occurrence', { changedInsertions });
			},
			openInsertion(insertion) {
				this.$emit('edit-insertion', insertion);
			},
			getParentCaptions(tag, param) {
				var res = serviceHelper
					.getParentEditableParametersSync(param, void 0, this.allServices)
					.filter(f => tag.paramsCaptions[f] || tag.params[f])
					.map(f => tag.paramsCaptions[f] ? tag.paramsCaptions[f] : `${f}: ${tag.params[f]}` ).join(', ');
				return res ? `, ${res}` : '';
			},
			getTagParams(tag, service) {
				return [
					...service.JsonDefinition.Parameters.filter(f => f.UserEditable).map(f => ({
						name: f.Name,
						value: tag.params[f.Name],
						displayValue: (tag.paramsCaptions[f.Name] || tag.params[f.Name]) + this.getParentCaptions(tag, f),
						caption: f.Caption,
						param: f,
						association: tag.associations[f.Name]
					})),
					...(service.JsonDefinition.ComplexParameters || []).map(f => ({
						name: f.Name,
						value: f.Keys.map(key => tag.params[`${f.Name}_${key}`]),
						displayValue: (f.Keys || []).map(key => `${key}: ${tag.params[`${f.Name}_${key}`]}`).join(', '),
						caption: f.Caption,
						isComplex: true,
						param: f,
						association: tag.associations[f.Name]
					})),
				];
			},
			getTime(secs) {
				return this.$moment.utc(secs).format(secs > 360000 ? 'HH:mm:ss' : 'mm:ss');
			},
			getInsertionText(ssml) {
				const el = document.createElement('div');
				el.innerHTML = ssml;
				const servicesTags = this.getNodes(el, 'adthos\\:wbs');
				servicesTags.map(f => f.innerHTML = ` ${f.getAttribute('outparam') || ''} `)
				return el.textContent || ssml;
			},
			getNodes(el, selector) {
				const tags = el.querySelectorAll(selector);
				const result = [];
				for(var i = 0; i < tags.length; i++) {
					result.push(tags[i]);
				}

				return result;
			},
			partText(text, divider, limit) {
				const index = text.indexOf(divider);
				if (index > -1) {
					return (index - limit > 0 ? '...' : '') + text.slice(Math.max(index - limit, 0), index + limit) + (index + limit < text.length ? '...' : '');
				}
				return text;
			},
			async detectServices() {
				if (!this.insertions?.length) {
					this.isLoaded = true;
					return;
				}
				try {
					this.isLoading++;
					const allServices = (await this.$Data.getExternalServices(0, 9999, { baseServices: true })).Results;
					this.allServices = allServices;

					const services = {};
					
					_.orderBy(this.insertions, ['StartTime']).map(insertion => {
						const el = document.createElement('div');
						const changedInsertion = this.changedInsertions[insertion.Oid];
						el.innerHTML = changedInsertion?.ssml || insertion.Ssml;
						const servicesTags = this.getNodes(el, 'adthos\\:wbs');

						servicesTags.map((tag, i) => {
							const id = tag.getAttribute('id');
							const service = allServices.find(f => f.Oid == id);
							if (service) {
								if (!services[id]) {
									services[id] = {
										service,
										insertions: [],
										expanded: true
									};
								}
								
								let tagInsertion = services[id].insertions.find(f => f.insertion === insertion);
								if (!tagInsertion) {
									tagInsertion = {
										tags: [],
										insertion
									}
									services[id].insertions.push(tagInsertion);
								}
								
								const params = {};
								const paramsCaptions = {};
								this.getNodes(tag, 'inparam').map(f => {
									params[f.getAttribute('name')] = f.getAttribute('val');
									if (f.getAttribute('caption')) {
										paramsCaptions[f.getAttribute('name')] = f.getAttribute('caption');
									}
								}, {});

								const associations = json5.parse(tag.getAttribute('templatefieldsassociation') || '{}');
								const tagHTML = tag.outerHTML;
								const marker = `>>>${tag.getAttribute('outparam')}<<<`;
								const markerDiv = document.createElement('div');
								markerDiv.innerHTML = marker;
								
								tag.after(markerDiv);
								tag.innerHTML = marker;
								const outparam = tag.getAttribute('outparam');
								tag.setAttribute('outparam', '');
								let hereText = this.partText(this.getInsertionText(el.innerHTML), marker, marker.length / 2 + 20);
								hereText = hereText.replace(marker, `<span class="managing-output">${outparam}</span>`);
								markerDiv.remove();
								tag.outerHTML = tagHTML;
								tagInsertion.tags.push({
									index: i,
									tagHTML: tagHTML,
									insertion,
									params,
									paramsCaptions,
									associations,
									insertionText: hereText,
									tag,
									ssml: el.firstChild
								})
							}
						});
					});

					this.services = Object.keys(services).map(f => services[f]);

					if (__DEBUG__)
						console.debug('Detect services', { services });
				} finally {
					this.isLoading--;
					this.isLoaded = true;
				}

				return this.services;
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.creative-services-manager {
		user-select: none;

		.service-margin {
			margin-left: 28px;
		}

		.insertion-text {
			max-width: 400px;
		}

		.managing-output {
			color: $base-accent;
		}

		.service {
			border-bottom: 1px solid #e4e4e4;
			padding-bottom: 20px;
		}

		.hoverable:hover {
			opacity: 0.7;
		}

		.associated-template-field {
			color: #4ed69b !important;
		}
	}
</style>
